import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { gql, useApolloClient, useMutation, useQuery } from '@apollo/client'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import { deletelocalstore, GetStore, deleteCustomerDeliverySlot, UpdateCustomerDeliverySlotActiveStatus } from '../apollo'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import { customStyles } from '../utils/tableStyleForSore'
import { Icon } from '@iconify/react';
import useGlobalStyles from '../utils/globalStyles'
import {
  Container,
  Button,
  Grid,
  Modal,
  MenuItem,
  IconButton,
  Menu,
  ListItemIcon,
  Typography,
  Paper, Box, Snackbar, Alert
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import TableHeader from '../components/TableHeader'
import CreateLocalStore from '../components/Vendor/CreateLocalStore'
import CustomerTimeSlotForLS from '../components/AdminConfiguration/CustomerTimeSlotForLS'

const GET_ALL_LOCAL_TIMECONFIG = gql`
${GetStore}
`
const DELETE_LOCAL_STORE = gql`
  ${deletelocalstore}
`

const DELETE_ALLTIME = gql`
  ${deleteCustomerDeliverySlot}
`
const UPDATE_SLOT_ACTIVE_STATUS = gql`
  ${UpdateCustomerDeliverySlotActiveStatus}
`;
const ManageCustomerTimeSlot = props => {
  const { t } = props;
  const [editModal, setEditModal] = useState(false)
  const [addVendorModal, setAddVendorModal] = useState(false)
  const [vendors, setVendor] = useState(null)
  const golbalClasses = useGlobalStyles()
  const [openSnackk, setopenSnackk] = useState(false);
  // Define a state to hold your query data
  const client = useApolloClient();
  let [error, errorSetter] = useState('');
  // const [error, errorSetter] = useState('');
  const [success, successSetter] = useState('');
  const userType = JSON.parse(localStorage.getItem('user-native'))
  const closeEditModal = () => {
    setEditModal(false);
    // setAddVendorModal(false);
  };

  const openaAddVendorModal = () => {
    setAddVendorModal(true);
  };
  const closeAddVendorModal = () => {
    setAddVendorModal(false);
  };

  const { loading: loadingQuery, error: errorQuery, data, refetch } = useQuery(
    GET_ALL_LOCAL_TIMECONFIG, {


    variables: { storeId: userType.storeId },

    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');

      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },

  }
  )

  useEffect(() => {
    // Manually trigger refetch when the component mounts
    refetch();
  }, []);
  // const { loading: loadingQuery, error: errorQuery, data, refetch } = useQuery(
  //   GET_VENDORS
  // )

  const [deleteMutate] = useMutation(DELETE_ALLTIME, {
    refetchQueries: [{ refetchQueries: GET_ALL_LOCAL_TIMECONFIG }],
    onError: ({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        errorSetter('An error occurred while deleting the Time SLot.');
        setTimeout(hideAlert, 3000);
        setopenSnackk(true)
      }
      if (networkError) {
        errorSetter(networkError.message);
        setTimeout(hideAlert, 3000);
      }
    },
    onCompleted: () => {
      const message = 'Time Slot  Deleted Successfully';
      refetch()
      errorSetter('');
      props.refetch()
      successSetter(message);
      setTimeout(hideAlert, 3000);
      setopenSnackk(true)
    }
  })
  const [updateSlotActiveStatus] = useMutation(UPDATE_SLOT_ACTIVE_STATUS, {
    onError: ({ graphQLErrors }) => {
      errorSetter('An error occurred while updating the time slot.');
      setopenSnackk(true);
      setTimeout(hideAlert, 3000);
    },
    onCompleted: () => {
      successSetter('Time slot updated successfully.');
      refetch();
      setopenSnackk(true);
      setTimeout(hideAlert, 3000);
    }
  });

  const [mutate] = useMutation(DELETE_LOCAL_STORE, {
    refetchQueries: [{ refetchQueries: GET_ALL_LOCAL_TIMECONFIG }],
    onError: ({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        errorSetter('An error occurred while deleting the Local Store.');
        setTimeout(hideAlert, 3000);
        setopenSnackk(true)
      }
      if (networkError) {
        errorSetter(networkError.message);
        setTimeout(hideAlert, 3000);
      }
    },
    onCompleted: () => {
      const message = 'Local Store Deleted Successfully';

      errorSetter('');
      props.refetch()
      successSetter(message);
      setTimeout(hideAlert, 3000);
      setopenSnackk(true)
    }
  })
  const hideAlert = () => {
    errorSetter('');
    successSetter('');
    setopenSnackk(false)
  };

  const filtered = data && data.getStore && data.getStore.customerDeliverySlot && data.getStore.customerDeliverySlot.timeSlot
  const toggleModal = vendor => {
    setEditModal(!editModal)
    setVendor(vendor)
  }

  useEffect(() => {
    localStorage.removeItem('restaurant_id')
  }, [])

  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field]) {
        return row[field].toLowerCase()
      }

      return row[field]
    }

    return orderBy(rows, handleField, direction)
  }

  useEffect(() => {
  }, [data])


  const columns = [
    {
      name: "Sl No.",
      cell: (row, index) => <>{index + 1}</>,
    },
    {
      name: "Start Time",
      sortable: true,
      selector: 'start',
      style: { cursor: 'pointer', minWidth: "200px" },
    },
    {
      name: "End Time",
      sortable: true,
      selector: 'end',
      style: { cursor: 'pointer', minWidth: "200px" },
    },
    {
      name: "Lead Time",
      sortable: true,
      cell: (row) => {
      const hours = Math.floor(row.leadTime);
      const minutes = Math.round((row.leadTime % 1) * 60);

      if (minutes === 0) return <>{hours}h</>;
      if (hours === 0) return <>{minutes}m</>;

      return <>{hours}h {minutes}m</>;
     }
    },
    {
      name: "Status",
      sortable: true,
      selector: 'isActive',
      cell: row => (
        <span style={{ color: row.isActive !== false ? 'green' : 'red' }}>
          {row.isActive !== false ? t('Active') : t('Inactive')}
        </span>
      ),
    },

    ...(userType.userType === 2
      ? [
        {
          name: "Action",
          cell: row => <>{actionButtons(row)}</>,
        },
      ]
      : []),
  ];


  const actionButtons = row => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = event => {
      setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
      setAnchorEl(null)
    }
    return (
      <>

        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-haspopup="true"
            onClick={handleClick}>
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Paper>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}>
              {userType.userType === 2 ? null : <MenuItem
                onClick={e => {
                  e.preventDefault()
                  setTimeout(() => {
                  }, 5000)
                  // uncomment this for paud version
                  toggleModal(row);
                }}

                style={{ height: 25 }}>
                <ListItemIcon>
                  <EditIcon fontSize="small" style={{ color: 'green' }} />
                </ListItemIcon>
                <Typography color="green">{t('Edit')}</Typography>
              </MenuItem>}
              <MenuItem
                onClick={(e) => {
                  e.preventDefault();
                  handleClose(); // close the menu

                  const isActive = row.isActive !== false;
                  const nextIsActive = !isActive;
                  const confirmation = window.confirm(
                    nextIsActive
                      ? "Do you want to activate this time slot?"
                      : "This time slot may have active orders. Deactivating it will hide it from active delivery slot selection.\n\nDo you want to continue?"
                  );

                  if (confirmation) {
                    updateSlotActiveStatus({
                      variables: {
                        id: row._id,
                        isActive: nextIsActive
                      }
                    });
                  }
                }}
                style={{ height: 25 }}
              >

                <ListItemIcon>
                  <DeleteIcon fontSize="small" style={{ color: row.isActive !== false ? 'red' : 'green' }} />
                </ListItemIcon>
                <Typography color={row.isActive !== false ? 'red' : 'green'}>
                  {row.isActive !== false ? t('Deactivate') : t('Activate')}
                </Typography>
              </MenuItem>
            </Menu>
          </Paper>
        </div>
      </>
    )
  }

  return (
    <>
      <Header />

      {/* {loadingQuery && <CustomLoader />} */}
      <Container className={golbalClasses.flex}>

        <Box sx={{ textAlign: 'right', mb: 3 }}>
          <Button

            className={golbalClasses.dashbordBtn}
            onClick={openaAddVendorModal}
          >
            <Icon icon="ic:twotone-plus" style={{ color: "white" }} />  {t('Add Time Slot')}
          </Button>
          {userType.userType === 2 ? <Button

            className={golbalClasses.dashbordDeleteBtn}
            onClick={() => deleteMutate()}
          >
            <Icon icon="ic:baseline-delete" style={{ color: "white" }} />  {t('Delete All Time Slot')}
          </Button> : null}
        </Box>
        {addVendorModal ? <Grid container>
          {/* <Grid item xs={12} order={{ xs: 2, lg: 1 }}> */}
          <Grid
            sx={{ display: { xs: 'none', lg: 'block' } }}
            item
            mt={5}
            ml={-2}
            order={{ xs: 1, lg: 2 }}
          >
            <Modal
              open={addVendorModal}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClose={closeAddVendorModal}
            >
              <CustomerTimeSlotForLS onClose={closeAddVendorModal} refetch={refetch} />
            </Modal>
          </Grid>
          {/* </Grid> */}
        </Grid> : null
        }
        {errorQuery && errorQuery ? <span> `Error! ${errorQuery.message}`</span> : null}
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <DataTable
            subHeader={true}

            title={<TableHeader title={t('Manage Customer Delivery Slot ')} />}
            // title={<TableHeader title={t('Vendors')} />}
            columns={columns}
            data={filtered || []}
            pagination
            progressPending={loadingQuery}
            progressComponent={<CustomLoader />}
            sortFunction={customSort}
            // defaultSortField="email"
            customStyles={customStyles}
          // selectableRows
          />
        )}
        <Modal
          open={editModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClose={() => {
            toggleModal()
          }}>
          <CustomerTimeSlotForLS vendor={vendors} editModal={editModal} onClose={closeEditModal} refetch={refetch} />
        </Modal>
        <Box mt={2}>
          {success && (
            <Snackbar open={openSnackk} autoHideDuration={6000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
              <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
                {success}
              </Alert>
            </Snackbar>
          )}
          {error && (
            <Snackbar open={openSnackk} autoHideDuration={6000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
              <Alert severity="error" variant="filled" sx={{ width: '100%' }}>
                {error}
              </Alert>
            </Snackbar>
          )}
        </Box>
      </Container>
    </>
  )
}

export default withTranslation()(ManageCustomerTimeSlot)
